import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-twq-loader',
    templateUrl: './twq-loader.component.html',
    styleUrls: ['./twq-loader.component.scss']
})
export class TwqLoaderComponent {
    @Input() isLoading: boolean = false;
}
